<template>
  <div class="course-container">
    <router-view />
    <div class="course-view">
      <editor :id="id" />
      <div v-if="draft.closed" class="footer-button-area">
        <div class="footer-button secondary" @click="deleteClosedCourse">删除</div>
        <div class="footer-button disabled">已完成</div>
      </div>
      <div v-else-if="draft.draft" class="footer-button-area">
        <div class="footer-button primary" @click="approveCourse">接受</div>
        <div class="footer-button secondary" @click="rejectCourse">拒绝</div>
      </div>
      <div v-else class="footer-button-area">
        <div class="footer-button default" @click="saveCourse">保存</div>
        <div class="footer-button primary" @click="finishCourse">完成</div>
        <div class="footer-button secondary" @click="deleteCourse">删除</div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import weui from '@/wechat/weui';
import { WeuiButtonArea, WeuiButton, WeuiMsg } from '@/components/weui';
import Editor from '@/components/course/Editor';
import dtos from '@/dtos/course';

import { COURSE_TYPE_COACH, COURSE_TYPE_PRIVATE } from '@/constants/types';
import { ROUTE_CALENDAR, ROUTE_PERIODIC_COURSE_EDITING, ROUTE_PERIODIC_COURSE_DELETING } from '@/router/names';
import {
    COURSE_DRAFT_FILL,
    FETCH_COURSE,
    PATCH_COURSE,
    DELETE_COURSE,
    CLOSE_COURSE,
    DELETE_CURRENT_COURSE,
} from '@/store/course/types';

const { mapState, mapActions, mapMutations } = createNamespacedHelpers('course');

export default {
    data() {
        return {
            id: 0,
        };
    },
    computed: {
        ...mapState({
            course: state => state.course || {},
            draft: state => state.draft,
        }),
        title() {
            if (this.draft.type === COURSE_TYPE_COACH) {
                return '自己训练';
            }
            if (this.draft.type === COURSE_TYPE_PRIVATE) {
                return '私人事件';
            }
            return `${this.course.user_name}的课程详情`;
        },
    },
    created() {
        const { id } = this.$route.params;
        const vm = this;

        this.id = Number.parseInt(id, 10);
        this.apiFetch({
            id,
        }).then(() => {
            document.title = this.title;
            vm.fillDraft({
                ...vm.course.original,
            });
        });
    },
    methods: {
        ...mapActions({
            apiFetch: FETCH_COURSE,
            apiPatch: PATCH_COURSE,
            apiDelete: DELETE_COURSE,
            apiDeleteCurrent: DELETE_CURRENT_COURSE,
            apiClose: CLOSE_COURSE,
        }),
        ...mapMutations({
            fillDraft: COURSE_DRAFT_FILL,
        }),
        async saveCourse() {
            if (this.id !== this.draft.id) {
                return;
            }

            if (dtos.periodic(this.draft)) {
                this.$router.push({
                    name: ROUTE_PERIODIC_COURSE_EDITING,
                    params: {
                        id: this.id,
                    },
                });
            } else {
                await this.apiPatch();
                await weui.toast('保存成功');
                this.$router.push({
                    name: ROUTE_CALENDAR,
                    query: {
                        date: this.draft.date,
                    },
                });
            }
        },
        async deleteCourse() {
            if (this.id !== this.draft.id) {
                return;
            }

            if (dtos.periodic(this.draft)) {
                this.$router.push({
                    name: ROUTE_PERIODIC_COURSE_DELETING,
                    params: {
                        id: this.id,
                    },
                });
            } else if (await weui.confirm('课程删除后无法恢复，确认删除吗？')) {
                this.apiDelete({ id: this.id });
                await weui.toast('删除成功');
                this.$router.replace({
                    name: ROUTE_CALENDAR,
                    query: {
                        date: this.draft.date,
                    },
                });
            }
        },
        async deleteClosedCourse() {
            if (this.id !== this.draft.id) {
                return;
            }

            if (!await weui.confirm('课程删除后无法恢复，确认删除吗？')) {
                return;
            }
            if (dtos.periodic(this.draft)) {
                await this.apiDeleteCurrent({ id: this.id });
            } else {
                await this.apiDelete({ id: this.id });
            }
            await weui.toast('删除成功');
            this.$router.replace({
                name: ROUTE_CALENDAR,
                query: {
                    date: this.draft.date,
                },
            });
        },
        async finishCourse() {
            if (this.id !== this.draft.id) {
                return;
            }

            await this.apiClose({ id: this.id });
            await weui.toast('课程已完成');
            this.$router.replace({
                name: ROUTE_CALENDAR,
            });
        },
        async approveCourse() {
            if (this.id !== this.draft.id) {
                return;
            }

            await this.apiPatch();
            await weui.toast('课程申请已接受');
            this.$router.push({
                name: ROUTE_CALENDAR,
            });
        },
        async rejectCourse() {
            if (this.id !== this.draft.id) {
                return;
            }

            if (await weui.confirm('确认拒绝课程申请吗？')) {
                await this.apiDelete({ id: this.draft.id });
                await weui.toast('课程申请已拒绝');
                this.$router.replace({
                    name: ROUTE_CALENDAR,
                });
            }
        },
    },
    components: {
        Editor,
        WeuiButtonArea,
        WeuiButton,
        WeuiMsg,
    },
};
</script>


<style lang="scss" scoped>
.course-view {
    padding-bottom: 18.666666666vw;
}

.footer-button-area {
    position: fixed;
    bottom: 0;
    width: 100vw;
    height: 13.333333333vw;
    display: flex;
    align-items: center;
    text-align: center;
    z-index: 100;

    .footer-button {
        flex: auto;
        font-size: 6.4vw;
        line-height: 13.333333333vw;

        &.primary {
            background-color: #448a13;
            color: white;
        }
        &.secondary {
            background-color: #fff;
            color: #6f6f6f;
        }
        &.default {
            background-color: #fff;
            color: #3b6c01;
        }
        &.disabled {
            background-color: #6f6f6f;
            color: white;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/containers/course/View.vue